interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="w-full px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/e54a5a0e-a70d-41b9-8886-2e667124ef92.png" 
              alt="ItsJustTax Logo" 
              className="h-10 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center gap-8">
            <a href="#forms" className={`font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>
              Tax Forms
            </a>
            <a href="#calculators" className={`font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>
              Calculators
            </a>
            <a href="#blog" className={`font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>
              Blog
            </a>
            <a href="#state-resources" className={`font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>
              Resources
            </a>
          </div>

          <div className="flex items-center gap-4">
            <button className={`p-2 rounded-full transition-colors cursor-pointer ${
              scrolled ? 'hover:bg-gray-100' : 'hover:bg-white/20'
            }`}>
              <i className={`ri-search-line text-xl ${scrolled ? 'text-gray-700' : 'text-white'}`}></i>
            </button>
            <a 
              href="https://aitaxforms.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-6 py-2 bg-white text-gray-900 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}